<template>
    <div class="row" v-if="roles.is_student">
        <div class="col-md-12">
            <div class="panel profile-panel profile-metrics">
                <template v-if="hasActions">
                    <div class="tw-flex tw-justify-end">
                        <a
                            class="tw-cursor-pointer text-danger hover:tw-text-red-dark tw-mr-6"
                            v-if="roles.is_owner && ! roles.is_public"
                            @click="destroyItem"
                        >
                            <i class="fa fa-times"></i>
                        </a>

                        <edit-button :modal-target='targetModal'/>
                    </div>
                    <h3 v-text="$t('wi.blast_metrics')" class="tw-mb-10 text-center"></h3>
                    <div class="tw-w-full tw-text-center">
                        <img src="/img/logos/powered-by-blast-iq.svg" alt="Blast IQ Logo">
                    </div>
                    <baseball-metrics v-if="isAcademyBaseball || isAcademySoftball"/>
                    <template v-if="isAcademyGolf">
                        <blast-simple-tabs>
                            <blast-tab id="putting_averages" :label="$t('wi.putting_averages')" :is-active="true" v-if="hasPutts">
                                <golf-metrics action-type="putt"/>
                            </blast-tab>

                            <blast-tab id="short_game_averages" :label="$t('wi.short_game_averages')" v-if="hasShortGames" :is-active="!hasPutts && !hasBunkers && !hasSwings">
                                <golf-metrics action-type="short_game"/>
                            </blast-tab>

                            <blast-tab id="bunker_averages" :label="$t('wi.bunker_averages')" v-if="hasBunkers" :is-active="!hasPutts && !hasShortGames && !hasSwings">
                                <golf-metrics action-type="bunker"/>
                            </blast-tab>

                            <blast-tab id="swing_averages" :label="$t('wi.full_swing_averages')" v-if="hasSwings" :is-active="!hasPutts && !hasBunkers && !hasShortGames">
                                <golf-metrics action-type="swing"/>
                            </blast-tab>
                        </blast-simple-tabs>
                    </template>
                </template>
                <empty-state
                        v-else
                        :title="$t('wi.blast_metrics')"
                        :description="$t('wi.your_blast_swing_metrics')"
                        :button="{caption: $t('wi.select_your_swing_metrics')}"
                        :modalTarget='targetModal'
                />

                <confirm-modal :state="showDeletionInfo" @close="closeInfo" @proceed="closeInfo" :proceedLabel="$t('wi.ok')" :showCancel="false">
                    <p>You previously published these metric(s) to your NCSA profile. If you wish to remove them from your NCSA profile, you’ll need to do that directly on your NCSA profile.</p>
                </confirm-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import academyMixin from '../../mixins/academy';
    import DeleteButton from '../VisualElements/DeleteButton';
    import BaseballMetrics from './BaseballMetrics';
    import GolfMetrics from './GolfMetrics';
    import EmptyState from '../EmptyState';
    import ProfileTabs from '../VisualElements/ProfileTabs';
    import ProfileTab from '../VisualElements/ProfileTab';
    import EditButton from '../VisualElements/EditButton';
    import deleteMixin from '../../mixins/delete';
    import ConfirmModal from '../VisualElements/ConfirmModal';

    export default {
        name: "Metrics",
        mixins: [academyMixin, deleteMixin],
        components: {
            EditButton,
            BaseballMetrics,
            EmptyState,
            GolfMetrics,
            ProfileTabs,
            ProfileTab,
            DeleteButton,
            ConfirmModal
        },
        data() {
            return {
                showDeletionInfo: false,
            }
        },
        computed: {
            ...mapGetters({
                roles: 'player-profile/roles',
                profileActions: 'player-profile/profileActions',
                ncsaProfile: 'player-profile/ncsaProfile'
            }),
            hasActions() {
                return this.profileActions ? this.hasPutts || this.hasSwings || this.profileActions.length > 0 : false;
            },
            targetModal() {
                return this.isAcademyBaseball || this.isAcademySoftball ? 'editMetrics' : 'editGolfMetrics';
            },
            hasPutts() {
                return this.profileActions.hasOwnProperty('putt') ? this.profileActions.putt.length > 0 : false;
            },
            hasSwings() {
                return this.profileActions.hasOwnProperty('swing') ? this.profileActions.swing.length > 0 : false;
            },
            hasShortGames() {
                return this.profileActions.hasOwnProperty('short_game') ? this.profileActions.short_game.length > 0 : false;
            },
            hasBunkers() {
                return this.profileActions.hasOwnProperty('bunker') ? this.profileActions.bunker.length > 0 : false;
            },
            getStatActionsId() {
                return this.profileActions.length > 0 ? this.profileActions[0].id : this.hasPutts ? this.profileActions.putt[0].id : this.profileActions.swing[0].id;
            }
        },
        methods: {
            destroyItem() {
                this.destroyProfileItem({
                    id: this.getStatActionsId,
                    type: 'stats_actions',
                    message: this.$t('wi.want_to_delete_these_metrics'),
                    callback: this.showInfo
                });
            },
            showInfo() {
                if (this.ncsaProfile) {
                    if (this.ncsaProfile.length) {
                        this.showDeletionInfo = _.head(this.ncsaProfile).metrics.length > 0;
                    }
                }
            },
            closeInfo() {
                this.showDeletionInfo = false;
            }
        }
    }
</script>

<style scoped>

</style>
